export const qualificationWinners = [
  {
    prize_1: {
      img: "rubick.png",
      imgBig: "rubick.jpg",
      title: "Комплект «The Magus Cypher»",
      titleDescr: "Набор для Rubick",
      hero: "Rubick",
      descr:
        "Многие маги считали, что Великая головоломка — это лишь занятная диковинка. И всё же целые поколения волшебников убивались в попытках её понять. Даже когда величайший маг посчитал, что раскрыл её секрет, он ещё долго не ведал её истинного смысла: знания, сокрытые внутри Великой головоломки, позволяли ему изменять саму природу магии. И теперь Rubick не просто виртуозно подражает чужому искусству. Отметая все пределы магических возможностей, он по своему велению меняет суть волшебства и непрестанно ищет и разгадывает новые сверхъестественные загадки. Быть может, они тоже откроют ему неведомые стороны чародейства."
    },
    winner_1: {
      id: 450,
      nickname: "iLOVEOKAYGGWP",
      steam_id64: "76561198051928894",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/30/30ea90a9391415e01d18f32353a1d5b2ff667437_full.jpg"
    },
    prize_2: {
      img: "monkey-king.png",
      imgBig: "monkey-king.jpg",
      title: "Комплект «Great Sage’s Reckoning»",
      titleDescr: "Набор для Monkey King",
      hero: "Monkey King",
      descr:
        "Пусть прегрешения Сунь Укуна были давно прощены, его волнующие свершения живы в нашей памяти и по сей день. Переживите три легендарных подвига из прошлых похождений героя. Этот предмет редкости Arcana для Monkey King включает в себя четыре динамических стиля, изменяющихся в ходе игры, измененную озвучку и новые анимации."
    },
    winner_2: {
      id: 251,
      nickname: "KAtala",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/f8/f8f46b29fa8993e68b782565989b93c6fedfc763_full.jpg",
      country: "RU",
      steam_id64: "76561198161942510"
    }
  },
  //2
  {
    prize_1: {
      img: "pudge.png",
      imgBig: "pudge.jpg",
      title: "Комплект «Feast of Abscession»",
      titleDescr: "Набор для Pudge",
      hero: "Pudge",
      descr:
        "Много веков назад мифическая волшебница Крелла сковала нерушимый крюк на цепи, что остановил бы самых могучих прислужников Мёртвого бога и отвадил бы погибель от её избранников. Но мор Мёртвого бога превзошёл даже легендарные заклинания Креллы. Одержимые песнью панихиды, цепи оставили свою госпожу и стали сокрушать её подданных, подчиняясь приказам Мёртвого бога. Теперь же, давно исполнив своё нечистое предназначение, цепи нашли себе нового господина... и новую добычу."
    },
    winner_1: {
      id: 825,
      nickname: "Ищу Путь Ниндзя",
      steam_id64: "76561198164096930",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/41/41f07e0de4f1583387401c540dc46fdaa3d68eba_full.jpg"
    },
    prize_2: {
      img: "techies.png",
      imgBig: "techies.jpg",
      title: "Комплект «Swine of the Sunken Galley»",
      titleDescr: "Набор для Techies",
      hero: "Techies",
      descr:
        "После месяцев работы подрывники Techies с гордостью представляют свое новейшее вооружение: The Swine, самую мощную в мире пушку. Во время первого своего выстрела она разорвала на части галеру, на которой стояла, и вылетела на берег. Через несколько дней ее нашли глубоко в скале прямо под мастерской ее создателей."
    },
    winner_2: {
      id: 733,
      nickname: "харьковская шпрота",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/66/66417c22cca24f292b5e7e67447d434e55a0696a_full.jpg",
      country: "NE",
      steam_id64: "76561198172140097"
    }
  },
  //3
  {
    prize_1: {
      img: "juggernaut.png",
      imgBig: "juggernaut.jpg",
      title: "Комплект «Bladeform Legacy»",
      titleDescr: "Набор для Juggernaut",
      hero: "Juggernaut",
      descr:
        "Маска Юрнеро раскололась надвое, пробудив покоившиеся в ней древние души. Они стали одним целым с Юрнеро, наделив его мудростью и яростью предков. Такой симбиоз превратил знакомого нам героя во что-то новое и пугающее… Снизошедшее до простых смертных стихийное бедствие."
    },
    winner_1: {
      id: 670,
      nickname: "prl",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/b5/b5e877432bee0e7f9031eace92a1a82d9ca8782b_full.jpg",
      country: null,
      steam_id64: "76561198033395482"
    },
    prize_2: {
      img: "lc.png",
      imgBig: "lc.jpg",
      title: "Blades of Volth Domosh",
      titleDescr: "Набор для Legion Commander (Оружие)",
      hero: "Legion Commander",
      descr:
        "Встав на путь мести против бездны, Тресдин посетила кузнеца Квита, о котором ходила недобрая молва. Он подарил ей эти адские клинки. Но слишком поздно может прийти осознание факта, что цена за использование такой силы будет намного больше того, с чем она готова расстаться..."
    },
    winner_2: {
      id: 351,
      nickname: "БАТУСАЙ СОКРУШИТЕЛЬ",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/cf/cf6b1c7c1e2d8ac786b1ae65fb4471871f924279_full.jpg",
      country: "PL",
      steam_id64: "76561198059485298"
    }
  },
  //4
  {
    prize_1: {
      img: "zeus.png",
      imgBig: "zeus.jpg",
      title: "«Tempest Helm of the Thundergod»",
      titleDescr: "Набор для Zeus",
      hero: "Zeus",
      descr:
        "Этот шлем, выкованный кланом Молотов Целестарра и наполненный энергией древних, словно влитой сидит на голове самого Повелителя небес. Неверующие содрогнутся, когда заслышат над полем боя раскаты грома!"
    },
    winner_1: {
      id: 576,
      nickname: "Arima",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/62/6281f32c1c5eb9dab4270b6c4a5107b0f718ad91_full.jpg",
      country: "KR",
      steam_id64: "76561198075199217"
    },
    prize_2: {
      img: "phantom-assasin.png",
      imgBig: "phantom-assasin.jpg",
      title: "Комплект «Manifold Paradox»",
      titleDescr: "Набор для Phantom Assasin",
      hero: "Phantom Assasin",
      descr:
        "Издав хриплый смешок, старший кузнец Крейлер взмахнул мечом, ковавшимся 11 поколениями его семьи. Он был настолько острым, что окружающий мир, с треском разорвавшейся материи, разошелся. Через этот разрыв Крейлер увидел себя несколькими мгновениями ранее, державшего тот же самый вожделенный меч. Вдруг, в приступе алчности и сумасшествия, он сразил своего двойника, чтобы заполучить второй меч. Но, с запозданием Крейлер почувствовал знакомую рану, и внезапно воспоминания о ней нахлынули на него..."
    },
    winner_2: {
      id: 232,
      nickname: "Admiral_Sapozhnik",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/c6/c66e5c746ffad4b9e44bc58c55583708863bb4bf_full.jpg",
      country: "RU",
      steam_id64: "76561198804702427"
    }
  },
  //5
  {
    prize_1: {
      img: "cm.png",
      imgBig: "cm.jpg",
      title: "Комплект «Frost Avalanche»",
      titleDescr: "Набор для Crystal Maiden",
      hero: "Crystal Maiden",
      descr:
        "Ходят слухи, что это одеяние было свадебным платьем древней королевы. По другим сведениям, оно являлось плащом ледяного огра. Однако, в действительности, эти зачарованные ткани изменчивы, как лавина, и могут принимать любые формы. Последняя форма привлекла одинокого волчонка, который стал выносливым и верным спутником."
    },
    winner_1: {
      id: 978,
      nickname: "Ange7",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/5f/5f119622b857230e5ff4ef4287513abaf0fb3c51_full.jpg",
      country: null,
      steam_id64: "76561198963739293"
    },
    prize_2: {
      img: "lina.png",
      imgBig: "lina.jpg",
      title: "Fiery Soul of the Slayer",
      titleDescr: "Набор для Lina (Голова)",
      hero: "Lina",
      descr:
        "Многие знают, что волосы Lina благословлены огнём, но лишь некоторые знают, почему. Когда Lina была ещё совсем молодой, именно дымящиеся и тлеющие волосы были первым признаком того, что она обладает огромной силой. Потребовались годы усердных тренировок, чтобы волшебница смогла контролировать подобные проявления своего таланта. Но, тем не менее, эту силу нельзя скрывать вечно, и в самые напряженные моменты битвы волосы Lina вспыхивают, показывая абсолютную концентрацию и высшую степень владения пламенем, которое способно испепелить всё на своем пути."
    },
    winner_2: {
      id: 1570,
      nickname: "diligently",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/22/2209f4a6a8860fdb62fe85978f71a33ef088d217_full.jpg",
      country: null,
      steam_id64: "76561198133005684"
    }
  },
  //6
  {
    prize_1: {
      img: "sf.png",
      imgBig: "sf.jpg",
      title: "Комплект «Inscribed Demon Eater»",
      titleDescr: "Набор для Shadow Fiend",
      hero: "Shadow Fiend",
      descr:
        "Shadow Fiend уже давно собирает души своих врагов. Как и у любого коллекционера, у него есть крайне ценные трофеи, которые хочется показать всем окружающим. Однако есть души, которые бы не следовало трогать, переполненные тьмой и яростью настолько, что ни одно живое существо не способно их удержать. Изменившись навсегда, Shadow Fiend познал плату за сбор душ демонов, но вместе с ней он познал и всю их мощь."
    },
    winner_1: {
      id: 523,
      nickname: "Ah",
      steam_id64: "76561198048714922",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/cb/cb114d8c0984bd4715a6a1c323be6fe4b25432c0_full.jpg"
    },
    prize_2: {
      img: "terror-blade.png",
      imgBig: "terror-blade.jpg",
      title: "Fractal Horns of Inner Abysm",
      titleDescr: "Набор для Terrorblade (Голова)",
      hero: "Terrorblade",
      descr:
        "Глубоко в аду внутри ада, Terrorblade был заключен в стенах своей тюрьмы-измерения, приговоренный к вечности извращенного созерцания. Он долго смотрел на отражение худшего себя. А то, в свою очередь, долго смотрело в него. Но теперь они сражаются бок о бок — единая сущность, более могущественная, чем когда-либо прежде."
    },
    winner_2: {
      id: 699,
      nickname: "Soloma",
      steam_id64: "76561198811489164",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/4a/4a111478f851c1937e95af5af5f56de90ed48571_full.jpg"
    }
  }
];
